import { BaseModel } from './base.model';
import { System } from './system.model';

export interface Subsystem {
    id: number;
    name: string;
    system: System;
}

export class Subsystem implements BaseModel {
    id: number;
    name: string;
    system: System;

    constructor();
    constructor(id: number, name: string, system: System);

    constructor(id?: number, name?: string, system?: System) {
      if (id !== undefined) {
        this.id = id;
      }

      if (name !== undefined) {
        this.name = name;
      } else {
        this.name = '';
      }

      if (system !== undefined) {
        this.system = system;
      } else {
        this.system = {} as System;
      }
    }

    getApiName(): string {
      return 'subsystem';
    }

    getName(): string {
      return 'Subsistema';
    }

    getNamePl(): string {
      return 'Subsistemas';
    }
  }